import React from 'react';
import PropTypes from 'prop-types';
import FilterOption from './FilterOption';
import Svg from '../../Svg';
import upperCaseFirst from 'upper-case-first';
import classNames from 'classnames';

function getSelectedOption(props) {
    return props.selected && props.options.find(option => (
            typeof option === 'object'
                ? props.selected === option.value
                : props.selected === option
        ));
}

function getDisplayName(props) {
    return props.displayName || upperCaseFirst(props.name);
}

function getDisplayValue(props) {
    const option = getSelectedOption(props);
    let displayValue = '';

    if (option) {
        displayValue = typeof option === 'object'
                ? option.displayName || upperCaseFirst(option.value)
                : upperCaseFirst(option);
    }

    return displayValue;
}

const FilterParameter = (props) =>
    <section
        className={classNames(
            'ui-filter__section ui-accordion__row',
            { hidden: props.hidden }
        )}
    >
        <ul
            className={classNames(
                'ui-filter__list ui-accordion__content',
                { hidden: !props.isExpanded }
            )}
        >
            {props.options.map((opt) => {
                let option = opt;
                if (typeof option !== 'object') {
                    option = {
                        value: option
                    };
                }

                return (
                    <FilterOption
                        {...option}
                        name={props.name}
                        key={option.value}
                        selected={
                            props.selected === option.value ||
                            option.value === '' &&
                            !props.selected
                        }
                        onOptionSelect={props.onOptionSelect}
                    />
                );
            })}
        </ul>
        <div
            className="ui-filter__sectionHeader ui-accordion__header"
            onClick={() => props.onParameterExpand(props.name)}
        >
            <span className="ui-filter__sectionHeader__title">
                <span>{getDisplayName(props)}</span>
                <span className="ui-filter__sectionHeader__label">{getDisplayValue(props)}</span>
            </span>
            <Svg
                size="Medium"
                iconName={props.isExpanded ? 'minus' : 'plus'}
            />
        </div>
    </section>;

FilterParameter.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onOptionSelect: PropTypes.func.isRequired,
    onParameterExpand: PropTypes.func.isRequired,
    isExpanded: PropTypes.bool,
    selected: PropTypes.any,
    displayName: PropTypes.string,
    hidden: PropTypes.bool,
};

export default FilterParameter;



// WEBPACK FOOTER //
// ./src/js/modules/Filter/components/FilterParameter.js